// Generated by ui/tools/i18n.mjs. Do not edit: add src/locales/<locale>.json and compile.
import type { Catalogues } from '@dugzi/ui';
import en from './en.generated';

export type { MessageId } from './en.generated';

export const catalogues: Catalogues = {
  en,
  nl: { status: 'machine-draft', load: () => import('./nl.generated').then((m) => m.default) },
  de: { status: 'machine-draft', load: () => import('./de.generated').then((m) => m.default) },
  fr: { status: 'machine-draft', load: () => import('./fr.generated').then((m) => m.default) },
};
